// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAmap from 'vue-amap'
import qrcodeDecoder from 'qrcode-decoder'
import App from './App'
import router from './router/router'
import store from './store/store.js'
import axios from 'axios'
// import axios from './utils/ajax'
import qs from 'qs'
import md5 from 'js-md5'
import ElementUI from 'element-ui'
import './assets/scss/element-variables.scss'
import './assets/scss/global.scss'
import './assets/scss/common.scss'
import Utils from './utils/utils'
import GuoyuLogo from './assets/images/guoyu-logo.jpg'
import HiliLogo from '../static/hili.jpg'
import { changeObj } from '@/utils/arr'
import {timeToDate , handleNull} from '@/utils/date-format';
import moment from 'moment';
import dayjs from "dayjs";
import changeTime from '@/utils/time'
//I18
import VueI18n from 'vue-i18n';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
//地图
import * as VueGoogleMaps from 'vue2-google-maps'
import Axios from "./utils/ajax";

Vue.use(VueI18n);
const messages = {
    en: {
      ...require('@/i18n/language-en'),
      ...enLocale
    },
    zh: {
      ...require('@/i18n/language-zh'),
      ...zhLocale
    }
  }
  const i18n = new VueI18n({
    locale: 'en',
    messages
  })
  Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
  })
//
Vue.prototype.$m = moment;
Vue.prototype.dayjs = dayjs;
Vue.prototype.$changeObj = changeObj;
Vue.prototype.$changeTime = changeTime;

Vue.prototype.$http = axios
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$qrcode = new qrcodeDecoder()
// Vue.use(ElementUI, { size: 'small', zIndex: 3000 })

Vue.use(VueAmap)

Vue.filter('timeToDate', timeToDate)
Vue.filter('handleNull', handleNull)

// Vue.prototype.$http.interceptors.response.use(response => {
//     if(response.config.url=="/client/sms/userInformation"){
//         return response;
//     }
//     let res = response.data;
//     let isLoginPage = router.currentRoute.fullPath.indexOf('loginPage') > -1;
//     let isWebview = router.currentRoute.fullPath.indexOf('electricWebview') > -1;
//     if(!isWebview&&!isLoginPage && res.mdata && res.mdata.errorCode && res.mdata.errorCode == '000'){
//         router.push("/");
//     }
//     return response;
// },  err => {
//     console.log(err);
// });

// 发送
Vue.prototype.$http.interceptors.request.use(
  request => {
    request.headers['Language-Type'] = 'en'
    return request;
  }
);

VueAmap.initAMapApiLoader({
    key:"35dbe243d669f8fbc33cd46defb43d6d",
    plugin:[
        "AMap.Autocomplete",
        "AMap.PlaceSearch",
        "AMap.Scale",
        "AMap.OverView",
        "AMap.ToolBar",
        "AMap.MapType",
        "AMap.PolyEditor",
        "AMap.CircleEditor",
        "AMap.Geolocation",
        "AMap.Geocoder",
        "AMap.AMapUI"
    ]
})

Vue.config.productionTip = false

let document = window.document;
// 设置网站标题、
let domain = Utils.getDomain();
if (domain == '38690001.lititi.com') {
    let links = document.getElementsByTagName("link");
    for (let i = 0; i < links.length; i ++) {
        let link = links[i];
        if (link.rel == 'icon' || link.rel == 'shortcut icon') {
            link.href = GuoyuLogo;
        }
    }
}
if (domain == 'hailixinnengyuan.com' || domain == 'leasehold-test.lititi.com'||domain=='leasehold-dev.lititi.com') {
    let links = document.getElementsByTagName("link");
    for (let i = 0; i < links.length; i ++) {
        let link = links[i];
        if (link.rel == 'icon' || link.rel == 'shortcut icon') {
          link.href = HiliLogo;
        }
    }
}
// 地图
Vue.use(VueGoogleMaps, {
  load: {
    // key:'AIzaSyDkrBQCY34HID_Jt0TMN-xb-MrhZ0ZFQtg',
    key:'AIzaSyBhL1KdJ-3jGM5T6qJ8pvD4BWd6gxvS40I',
    libraries: 'visualization', // This is required if you use the Autocomplete plugin
  },
  installComponents: true
})
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js